import './firebase-app';
import { getAuth } from 'firebase/auth';
import { watch } from 'vue';

import { locale } from '@/context';

const auth = getAuth();
watch(
  locale,
  (locale) => {
    if (locale) auth.languageCode = locale;
  },
  { immediate: true },
);
